import { lazy } from "react";
import { createFormHook } from "@tanstack/react-form";
import { fieldContext, formContext } from "./context";
import { TextField } from "./text-field";
import { TextArea } from "./text-area";
import { NumberField } from "./number-field";
import { Checkbox } from "./checkbox";
import { Switch } from "./switch";
import { ChoiceList } from "./choice-list";
import { ColorField } from "./color-field";
import { SliderField } from "./slider-field";
import { SelectField } from "./select-field";

// CodeMirror 有一百多 KB，静态引入会被卷进共享 chunk（index.html 直接加载的那个），
// 所以按需拉；用到的地方自己包 Suspense。
const CodeEditor = lazy(() =>
  import("./code-editor").then((module) => ({ default: module.CodeEditor })),
);

export const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField,
    TextArea,
    CodeEditor,
    NumberField,
    Checkbox,
    Switch,
    ChoiceList,
    ColorField,
    SliderField,
    SelectField,
  },
  formComponents: {},
});
